import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { SeedOrderApiRecord } from './types'

const seedOrdersDict = (state: AppGlobalState) => state.seedOrders.items
const ids = (state: AppGlobalState) => state.seedOrders.ids
const listFetchProgress = (state: AppGlobalState) => state.seedOrders.listFetchProgress
const seedOrdersList = createSelector(seedOrdersDict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: SeedOrderApiRecord[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.seedOrders.filter
const sorting = (state: AppGlobalState) => state.seedOrders.sorting
const page = (state: AppGlobalState) => state.seedOrders.page
const total = (state: AppGlobalState) => state.seedOrders.total
const pageSize = (state: AppGlobalState) => state.seedOrders.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.seedOrders.total / state.seedOrders.pageSize)

const seedOrder = (state: AppGlobalState, id: string) => seedOrdersDict(state)[id]
const meta = (state: AppGlobalState, id: string) =>
  state.seedOrders.meta[id] || { fetchProgress: Progress.IDLE, fetchError: null }

const SeedOrdersSelectors = {
  filter,
  sorting,
  page,
  total,
  seedOrdersDict,
  ids,
  seedOrdersList,
  pageSize,
  pages,
  listFetchProgress,
  seedOrder,
  meta,
}

export default SeedOrdersSelectors
